import React from 'react';
import MViewSummaryAnswerFormListItems from './MViewSummaryAnswerFormListItems';
import LoadingButton from '../../../app/common/layout/LoadingButton';

export default function MViewSummaryFormList(props) {
  const {
    auth,
    scope,
    loading,
    state,
    questions,
    onChangeInput,
    handleEnter,
    isEdit,
    roundNumber,
  } = props;
  return (
    <>
      {loading && (
        <tr>
          <td rowSpan={4}>
            <LoadingButton />
          </td>
        </tr>
      )}
      {questions?.[0] &&
        questions.map((question, index) => (
          <MViewSummaryAnswerFormListItems
            auth={auth}
            scope={scope}
            key={index}
            index={index}
            state={state}
            question={question}
            onChangeInput={onChangeInput}
            handleEnter={handleEnter}
            isEdit={isEdit}
            roundNumber={roundNumber}
          />
        ))}
      {!questions?.[0] && (
        <tr>
          <td colSpan={4}>Tidak ada data</td>
        </tr>
      )}
    </>
  );
}
